/*****************************************************************************
 *
 * Constant definitions of the table columns data types, labels, and formats
 * used throughout the application
 *
 *****************************************************************************/

import PropTypes from "prop-types";

import {VARIABLES} from "./constants";
import {VARIABLE_LABELS_SHORT, VARIABLE_LABELS_LONG} from "./strings";

import FormattedNumber from "../components/Controls/FormattedNumber";

export const COLUMN_SHAPE = PropTypes.shape({
  field: PropTypes.string.isRequired,
  label: PropTypes.node,
  isHeader: PropTypes.bool,
  format: PropTypes.func,
  className: PropTypes.string
});

export const TOTAL_SELECTION_COLUMNS = [{
  isHeader: true,
  field: VARIABLES.Location,
  label: VARIABLE_LABELS_SHORT.Location,
}, {
  field: VARIABLES.POP,
  label: VARIABLE_LABELS_SHORT.POP,
  format: FormattedNumber.renderInteger
}, {
  field: VARIABLES.TotalCost,
  label: VARIABLE_LABELS_SHORT.TotalCost,
  format: FormattedNumber.renderCurrency
}, {
  field: VARIABLES.Cost_perCapita,
  label: VARIABLE_LABELS_SHORT.Cost_perCapita,
  format: FormattedNumber.renderCurrency
}];

export const NONFATAL_SELECTION_COLUMNS = [{
  isHeader: true,
  field: VARIABLES.Location,
  label: VARIABLE_LABELS_SHORT.Location,
}, {
  field: VARIABLES.POP,
  label: VARIABLE_LABELS_SHORT.POP,
  format: FormattedNumber.renderInteger
}, {
  field: VARIABLES.OUDC_Total,
  label: VARIABLE_LABELS_SHORT.OUDC_Total,
  format: FormattedNumber.renderCurrency
}, {
  field: VARIABLES.OUDC_perCapita,
  label: VARIABLE_LABELS_SHORT.OUDC_perCapita,
  format: FormattedNumber.renderCurrency
}];

export const FATAL_SELECTION_COLUMNS = [{
  isHeader: true,
  field: VARIABLES.Location,
  label: VARIABLE_LABELS_SHORT.Location,
}, {
  field: VARIABLES.POP,
  label: VARIABLE_LABELS_SHORT.POP,
  format: FormattedNumber.renderInteger
}, {
  field: VARIABLES.FODC_Total,
  label: VARIABLE_LABELS_SHORT.FODC_Total,
  format: FormattedNumber.renderCurrency
}, {
  field: VARIABLES.FODC_perCapita,
  label: VARIABLE_LABELS_SHORT.FODC_perCapita,
  format: FormattedNumber.renderCurrency
}];

export const TOTAL_DETAIL_COLUMNS = [{
  isHeader: true,
  field: VARIABLES.Location,
  label: VARIABLE_LABELS_SHORT.Location,
}, {
  field: VARIABLES.OUDC_Total,
  label: VARIABLE_LABELS_SHORT.OUDC_Total,
  format: FormattedNumber.renderCurrency
}, {
  field: VARIABLES.FODC_Total,
  label: VARIABLE_LABELS_SHORT.FODC_Total,
  format: FormattedNumber.renderCurrency
}, {
  field: VARIABLES.TotalCost,
  label: VARIABLE_LABELS_SHORT.TotalCost,
  format: FormattedNumber.renderCurrency
}, {
  field: VARIABLES.Cost_perCapita,
  label: VARIABLE_LABELS_SHORT.Cost_perCapita,
  format: FormattedNumber.renderCurrency
}];

export const NONFATAL_DETAIL_COLUMNS = [{
  isHeader: true,
  field: VARIABLES.Location,
  label: VARIABLE_LABELS_SHORT.Location,
}, {
  field: VARIABLES.OUDC_HealthCare,
  label: VARIABLE_LABELS_SHORT.OUDC_HealthCare,
  format: FormattedNumber.renderCurrency
}, {
  field: VARIABLES.OUDC_Treatment,
  label: VARIABLE_LABELS_SHORT.OUDC_Treatment,
  format: FormattedNumber.renderCurrency
}, {
  field: VARIABLES.OUDC_CriminalJustice,
  label: VARIABLE_LABELS_SHORT.OUDC_CriminalJustice,
  format: FormattedNumber.renderCurrency
}, {
  field: VARIABLES.OUDC_LostProductivity,
  label: VARIABLE_LABELS_SHORT.OUDC_LostProductivity,
  format: FormattedNumber.renderCurrency
}, {
  field: VARIABLES.OUDC_RQL,
  label: VARIABLE_LABELS_SHORT.OUDC_RQL,
  format: FormattedNumber.renderCurrency
}, {
  field: VARIABLES.OUDC_Total,
  label: VARIABLE_LABELS_SHORT.OUDC_Total,
  format: FormattedNumber.renderCurrency
}, {
  field: VARIABLES.OUDC_perCapita,
  label: VARIABLE_LABELS_SHORT.OUDC_perCapita,
  format: FormattedNumber.renderCurrency
}];

export const FATAL_DETAIL_COLUMNS = [{
  isHeader: true,
  field: VARIABLES.Location,
  label: VARIABLE_LABELS_SHORT.Location,
}, {
  field: VARIABLES.FODC_HealthCare,
  label: VARIABLE_LABELS_SHORT.FODC_HealthCare,
  format: FormattedNumber.renderCurrency
}, {
  field: VARIABLES.FODC_LostProductivity,
  label: VARIABLE_LABELS_SHORT.FODC_LostProductivity,
  format: FormattedNumber.renderCurrency
}, {
  field: VARIABLES.FODC_VSL,
  label: VARIABLE_LABELS_SHORT.FODC_VSL,
  format: FormattedNumber.renderCurrency
}, {
  field: VARIABLES.FODC_Total,
  label: VARIABLE_LABELS_SHORT.FODC_Total,
  format: FormattedNumber.renderCurrency
}, {
  field: VARIABLES.FODC_perCapita,
  label: VARIABLE_LABELS_SHORT.FODC_perCapita,
  format: FormattedNumber.renderCurrency
}];

export const TOTAL_EXPORT_COLUMNS = [{
  field: VARIABLES.Location,
  label: VARIABLE_LABELS_LONG.Location
}, {
  field: VARIABLES.OUDC_Total,
  label: VARIABLE_LABELS_LONG.OUDC_Total
}, {
  field: VARIABLES.FODC_Total,
  label: VARIABLE_LABELS_LONG.FODC_Total
}, {
  field: VARIABLES.TotalCost,
  label: VARIABLE_LABELS_LONG.TotalCost
}, {
  field: VARIABLES.Cost_perCapita,
  label: VARIABLE_LABELS_LONG.Cost_perCapita
}];

export const NONFATAL_EXPORT_COLUMNS = [{
  field: VARIABLES.Location,
  label: VARIABLE_LABELS_LONG.Location
}, {
  field: VARIABLES.OUDC_HealthCare,
  label: VARIABLE_LABELS_LONG.OUDC_HealthCare
}, {
  field: VARIABLES.OUDC_Treatment,
  label: VARIABLE_LABELS_LONG.OUDC_Treatment
}, {
  field: VARIABLES.OUDC_CriminalJustice,
  label: VARIABLE_LABELS_LONG.OUDC_CriminalJustice
}, {
  field: VARIABLES.OUDC_LostProductivity,
  label: VARIABLE_LABELS_LONG.OUDC_LostProductivity
}, {
  field: VARIABLES.OUDC_RQL,
  label: VARIABLE_LABELS_LONG.OUDC_RQL
}, {
  field: VARIABLES.OUDC_Total,
  label: VARIABLE_LABELS_LONG.OUDC_Total
}, {
  field: VARIABLES.OUDC_perCapita,
  label: VARIABLE_LABELS_LONG.OUDC_perCapita
}];

export const FATAL_EXPORT_COLUMNS = [{
  field: VARIABLES.Location,
  label: VARIABLE_LABELS_LONG.Location
}, {
  field: VARIABLES.FODC_HealthCare,
  label: VARIABLE_LABELS_LONG.FODC_HealthCare
}, {
  field: VARIABLES.FODC_LostProductivity,
  label: VARIABLE_LABELS_LONG.FODC_LostProductivity
}, {
  field: VARIABLES.FODC_VSL,
  label: VARIABLE_LABELS_LONG.FODC_VSL
}, {
  field: VARIABLES.FODC_Total,
  label: VARIABLE_LABELS_LONG.FODC_Total
}, {
  field: VARIABLES.FODC_perCapita,
  label: VARIABLE_LABELS_LONG.FODC_perCapita
}];

export const SUMMARY_EXPORT_COLUMNS = [{
  field: VARIABLES.Location,
  label: VARIABLE_LABELS_LONG.Location,
}, {
  field: VARIABLES.OUDC_Total,
  label: VARIABLE_LABELS_LONG.OUDC_Total
}, {
  field: VARIABLES.FODC_Total,
  label: VARIABLE_LABELS_LONG.FODC_Total
}, {
  field: VARIABLES.TotalCost,
  label: VARIABLE_LABELS_LONG.TotalCost
}, {
  field: VARIABLES.Cost_perCapita,
  label: VARIABLE_LABELS_LONG.Cost_perCapita
}, {
  field: VARIABLES.OUDC_HealthCare,
  label: VARIABLE_LABELS_LONG.OUDC_HealthCare
}, {
  field: VARIABLES.OUDC_Treatment,
  label: VARIABLE_LABELS_LONG.OUDC_Treatment
}, {
  field: VARIABLES.OUDC_CriminalJustice,
  label: VARIABLE_LABELS_LONG.OUDC_CriminalJustice
}, {
  field: VARIABLES.OUDC_LostProductivity,
  label: VARIABLE_LABELS_LONG.OUDC_LostProductivity
}, {
  field: VARIABLES.OUDC_RQL,
  label: VARIABLE_LABELS_LONG.OUDC_RQL
}, {
  field: VARIABLES.OUDC_Total,
  label: VARIABLE_LABELS_LONG.OUDC_Total
}, {
  field: VARIABLES.OUDC_perCapita,
  label: VARIABLE_LABELS_LONG.OUDC_perCapita
}, {
  field: VARIABLES.FODC_HealthCare,
  label: VARIABLE_LABELS_LONG.FODC_HealthCare
}, {
  field: VARIABLES.FODC_LostProductivity,
  label: VARIABLE_LABELS_LONG.FODC_LostProductivity
}, {
  field: VARIABLES.FODC_VSL,
  label: VARIABLE_LABELS_LONG.FODC_VSL
}, {
  field: VARIABLES.FODC_Total,
  label: VARIABLE_LABELS_LONG.FODC_Total
}, {
  field: VARIABLES.FODC_perCapita,
  label: VARIABLE_LABELS_LONG.FODC_perCapita
}];
